<div class="left-sidenav tpo-report-card" id="{{uniqueId}}" [class.disclosures-processing]="disclosuresPending">
  @let basePath = '/tpo/app-details/' + loanId;
  <div class="menu-content h-100">
    <ul class="left-sidenav-menu sticky">

      <li [hidden]="(isCompanyPulseProcessing && !tpoSubmitted) || disabledTpoAppMenuItems?.includes('LoanSummary')"
        (click)="onListItemClicked($event, 'loan-summary')" class="tpo-parent-menu-item"
        [ngClass]="{'mm-active': tab === 'loan-summary'}">
        <a [routerLink]="isCompanyPulseProcessing ? [basePath + '/tpo-loan-summary'] : [basePath + '/loan-summary']">
          @if (isLoanSummaryStepRequiredForCustomInfo) {
            <ng-container
              *ngTemplateOutlet="statusIndicator; context: {status: !isUrlaReadOnly ? stepStatuses.loanSummary : 'success'}">
            </ng-container>
            <span>{{ showStepLabels ? 'Step ' + stepOrder['loanSummary'] + ': ' : '' }}Loan Summary</span>
          } @else {
            <i class="status-indicator pi pi-question-circle text-warning"></i>
            <span>Loan Summary</span>
          }
        </a>
      </li>

      <li
        [hidden]="!isManualPricingEntryAvailable || !isReverseMortgage || disabledTpoAppMenuItems?.includes('Pricing')"
        (click)="onListItemClicked($event, 'pricing')" class="tpo-parent-menu-item"
        [ngClass]="{'mm-active': tab === 'pricing'}">
        <a [routerLink]="[basePath + '/edit-pricing']">
          <ng-container *ngTemplateOutlet="statusIndicator; context: {status: stepStatuses.pricing}"></ng-container>
          <span>{{ showStepLabels ? 'Step ' + stepOrder['pricing'] + ': ' : '' }}Pricing</span></a>
      </li>

      @let isPricingMenuActive = activeMenuId === 'pricing';
      <li class="tpo-parent-menu-item has-section-toggle"
        [ngClass]="{'mm-active': tab === 'pricing', 'mm-sub-active': isPricingMenuActive && tab !== 'pricing'}"
        [hidden]="!featurePermissions.pricingEnabled || isManualPricingEntryAvailable || !isReverseMortgage || disabledTpoAppMenuItems?.includes('Pricing')">

        <a [routerLink]="[basePath + '/pricing']" (click)="expandMenu('pricing')">
          <span>
            <ng-container *ngTemplateOutlet="statusIndicator; context: {status: stepStatuses.pricing}"></ng-container>
            {{ showStepLabels ? 'Step ' + stepOrder['pricing'] + ': ' : '' }}Pricing</span>
          @if (!pricingVendorsAreOnlyIframes || pollyIframeScenarioPricingEnabled) {
          <i class="ms-auto fa-solid fa-chevron-right text-muted section-toggle-icon" style="font-size: 0.7rem;" [class.is-open]="isPricingExpanded" aria-hidden="true"></i>
          }
        </a>
        @if (!pricingVendorsAreOnlyIframes || pollyIframeScenarioPricingEnabled) {
        <button type="button" class="section-toggle" [attr.aria-expanded]="isPricingExpanded"
          aria-label="Pricing submenu" (click)="toggleMenuExpansion('pricing')"></button>
        <ul class="nav-second-level mm-collapse" aria-expanded="false" [ngClass]="{'mm-show': isPricingExpanded}">
          @if (isReverseMortgage && !disabledTpoAppMenuItems?.includes('PricingScenarios')) {
          <li class="nav-item" [ngClass]="{'mm-active': tab === 'application-pricing-scenarios'}">
            <a class="nav-link" [routerLink]="[basePath + '/application-pricing-scenarios']">
              <i class="status-indicator pi pi-question-circle text-warning"></i>
              <span> Pricing Scenarios </span>
            </a>
          </li>
          }
          @if(!pricingVendorsAreOnlyIframes && !disabledTpoAppMenuItems?.includes('PricingHistory')){
          <li class="nav-item" [ngClass]="{'mm-active': tab === 'pricing-history'}">
            <a class="nav-link" [routerLink]="[basePath + '/pricing-history']">
              <i class="status-indicator pi pi-question-circle text-warning"></i>
              <span> Pricing History </span>
            </a>
          </li>
          }

          @if (!isReverseMortgage && !disabledTpoAppMenuItems?.includes('PricingScenarios')) {
          <li class="nav-item" [ngClass]="{'mm-active': tab === 'application-pricing-scenarios'}">
            <a class="nav-link" [routerLink]="[basePath + '/application-pricing-scenarios']">
              <i class="status-indicator pi pi-question-circle text-warning"></i>
              <span> Pricing Scenarios </span>
            </a>
          </li>
          }
        </ul>
        }
      </li>

      @let isUrlaActive = isUrlaExpanded || tab === 'urla';
      <li class="tpo-parent-menu-item" [ngClass]="{'mm-active': isUrlaActive}"
        [hidden]="disabledTpoAppMenuItems?.includes('Urla')">
        <a [routerLink]="[basePath + '/urla']" [attr.aria-expanded]="isUrlaExpanded"
          (click)="toggleMenuExpansion('urla')">
          <span [ngClass]="{'readonlyIcon': isUrlaReadOnly}">
            @if (!isUrlaReadOnly || stepStatuses.submission != 'success') {
            <ng-container
              *ngTemplateOutlet="statusIndicator; context: {status: !isUrlaReadOnly ? stepStatuses.urla : 'success'}">
            </ng-container>
            }
            {{ showStepLabels ? 'Step ' + stepOrder['urla'] + ': ' : '' }}{{isSmartfi ? 'Application' :
            isCompanyPulseProcessing ? 'URLA' : 'URLA 2020'}}</span>

          <i class="ms-auto fa-solid text-muted" style="font-size: 0.7rem;"
            [ngClass]="isUrlaExpanded ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
        </a>
        <ul class="nav-second-level mm-collapse" aria-expanded="false" [ngClass]="{'mm-show': isUrlaExpanded}">
          @if (tab === 'urla') {
          <urla-menu (menuItemClicked)='onUrlaMenuItemClicked($event)'></urla-menu>
          }
        </ul>
      </li>

      @let isServicesActive = activeMenuId === 'services';
      <li class="has-section-toggle"
        [hidden]="!featurePermissions.isServicesEnabled || channel == 'Correspondent' || isSmartfi || disabledTpoAppMenuItems?.includes('Services')"
        [ngClass]="{'mm-sub-active': isServicesActive}">
        <a href="javascript: void(0);" [attr.aria-expanded]="isServicesExpanded" (click)="toggleMenuExpansion('services')">
          <span>
            <ng-container *ngTemplateOutlet="statusIndicator; context: {status: stepStatuses.services}"></ng-container>
            {{ showStepLabels ? 'Step ' + stepOrder['services'] + ': ' : '' }}Services</span>
          <i class="ms-auto fa-solid fa-chevron-right text-muted section-toggle-icon" style="font-size: 0.7rem;" [class.is-open]="isServicesExpanded" aria-hidden="true"></i>
        </a>
        <button type="button" class="section-toggle" [attr.aria-expanded]="isServicesExpanded"
          aria-label="Services submenu" (click)="toggleMenuExpansion('services')"></button>
        <ul class="nav-second-level mm-collapse" aria-expanded="false" [ngClass]="{'mm-show': isServicesExpanded}">
          <menu-item [hidden]="!featurePermissions.isCreditAllowed || disabledTpoAppMenuItems?.includes('Credit')"
            [label]="'Credit'" (menuItemClicked)="onMenuItemClicked($event)" [link]="basePath + '/credit-reports'" [isActive]="tab === 'credit-reports'"
            [status]="MenuItemStatus.None" [id]="'credit'" [groupId]="'services'">
          </menu-item>
          <menu-item [hidden]="!featurePermissions.isVoiVoeAllowed || disabledTpoAppMenuItems?.includes('VoiVoe')"
            [label]="'VOI/VOE'" (menuItemClicked)="onMenuItemClicked($event)"
            [link]="basePath + '/digital-emp-income-verification'" [isActive]="tab === 'digital-emp-income-verification'" [status]="MenuItemStatus.None" [id]="'voi-voe'"
            [groupId]="'services'">
          </menu-item>
          <menu-item [hidden]="!featurePermissions.isVoaAllowed || disabledTpoAppMenuItems?.includes('Voa')"
            [label]="'VOA'" (menuItemClicked)="onMenuItemClicked($event)"
            [link]="basePath + '/digital-asset-verification'" [isActive]="tab === 'digital-asset-verification'" [status]="MenuItemStatus.None" [id]="'voa'"
            [groupId]="'services'">
          </menu-item>
          <menu-item [hidden]="!featurePermissions.isAusAllowed || disabledTpoAppMenuItems?.includes('Aus')"
            [label]="'AUS'" (menuItemClicked)="onMenuItemClicked($event)" [link]="basePath + '/aus'" [isActive]="tab === 'aus'"
            [status]="MenuItemStatus.None" [id]="'aus'" [groupId]="'services'">
          </menu-item>
          <menu-item [hidden]="!isMiQuoteVisible || disabledTpoAppMenuItems?.includes('MiQuote')"
            [label]="'PMI Quote'" (menuItemClicked)="onMenuItemClicked($event)"
            [link]="basePath + '/mi-quoting'" [isActive]="tab === 'mi-quoting'" [status]="MenuItemStatus.None" [id]="'mi-quoting'"
            [groupId]="'services'">
          </menu-item>
          <menu-item [hidden]="!featurePermissions.isLinkEnabled || disabledTpoAppMenuItems?.includes('Link')"
            [label]="'LINK'" (menuItemClicked)="onMenuItemClicked($event)" [link]="basePath + '/link'" [isActive]="tab === 'link'"
            [status]="MenuItemStatus.None" [id]="'link'" [groupId]="'services'">
          </menu-item>
          <menu-item
            [hidden]="!featurePermissions.isLinkCalculatorEnabled || disabledTpoAppMenuItems?.includes('LinkIncomeCalc')"
            [label]="'LINK Income Calculator'" (menuItemClicked)="onMenuItemClicked($event)"
            [link]="basePath + '/link-income-calculator'" [isActive]="tab === 'link-income-calculator'" [status]="MenuItemStatus.None" [id]="'link-income-calculator'"
            [groupId]="'services'">
          </menu-item>
          <menu-item
            [hidden]="!featurePermissions.isIncomeAnalysisEnabled || disabledTpoAppMenuItems?.includes('IncomeAnalysis')"
            [label]="'Income Analysis'" (menuItemClicked)="onMenuItemClicked($event)"
            [link]="basePath + '/income-analysis'" [isActive]="tab === 'income-analysis'" [status]="MenuItemStatus.None" [id]="'income-analysis'"
            [groupId]="'services'">
          </menu-item>
        </ul>
      </li>

      <li [hidden]="!(isCompanyPulseProcessing && !tpoSubmitted) || disabledTpoAppMenuItems?.includes('LoanSummary')"
        (click)="onListItemClicked($event, 'loan-summary')" class="tpo-parent-menu-item"
        [ngClass]="{'mm-active': tab === 'loan-summary'}">
        <a [routerLink]="isCompanyPulseProcessing ? [basePath + '/tpo-loan-summary'] : [basePath + '/loan-summary']">
          <i class="status-indicator pi pi-question-circle text-warning"></i>
          <ng-container
            *ngTemplateOutlet="statusIndicator; context: {status: !isUrlaReadOnly ? stepStatuses.loanSummary : 'success'}">
          </ng-container>
          <span>{{ showStepLabels ? 'Step ' + stepOrder['loanSummary'] + ': ' : '' }}Loan Summary</span>
        </a>
      </li>

      <li [hidden]="!isManualPricingEntryAvailable || isReverseMortgage || disabledTpoAppMenuItems?.includes('Pricing')"
        (click)="onListItemClicked($event, 'pricing')" class="tpo-parent-menu-item"
        [ngClass]="{'mm-active': tab === 'pricing'}">
        <a [routerLink]="[basePath + '/edit-pricing']">
          <ng-container *ngTemplateOutlet="statusIndicator; context: {status: stepStatuses.pricing}"></ng-container>
          <span>{{ showStepLabels ? 'Step ' + stepOrder['pricing'] + ': ' : '' }}Pricing</span></a>
      </li>

      <li class="tpo-parent-menu-item has-section-toggle"
        [ngClass]="{'mm-active': tab === 'pricing', 'mm-sub-active': isPricingMenuActive && tab !== 'pricing'}"
        [hidden]="!featurePermissions.pricingEnabled || isManualPricingEntryAvailable || isReverseMortgage || disabledTpoAppMenuItems?.includes('Pricing')">

        <a [routerLink]="[basePath + '/pricing']" (click)="expandMenu('pricing')">
          <span>
            <ng-container *ngTemplateOutlet="statusIndicator; context: {status: stepStatuses.pricing}"></ng-container>
            {{ showStepLabels ? 'Step ' + stepOrder['pricing'] + ': ' : '' }}Pricing</span>
          @if (!pricingVendorsAreOnlyIframes || pollyIframeScenarioPricingEnabled) {
          <i class="ms-auto fa-solid fa-chevron-right text-muted section-toggle-icon" style="font-size: 0.7rem;" [class.is-open]="isPricingExpanded" aria-hidden="true"></i>
          }
        </a>
        @if (!pricingVendorsAreOnlyIframes || pollyIframeScenarioPricingEnabled) {
        <button type="button" class="section-toggle" [attr.aria-expanded]="isPricingExpanded"
          aria-label="Pricing submenu" (click)="toggleMenuExpansion('pricing')"></button>
        <ul class="nav-second-level mm-collapse" aria-expanded="false" [ngClass]="{'mm-show': isPricingExpanded}">
          @if (isReverseMortgage && !disabledTpoAppMenuItems?.includes('PricingScenarios')) {
          <li class="nav-item" [ngClass]="{'mm-active': tab === 'application-pricing-scenarios'}"
            (click)="onListItemClicked($event, 'application-pricing-scenarios')">
            <a class="nav-link" [routerLink]="[basePath + '/application-pricing-scenarios']">
              <i class="status-indicator pi pi-question-circle text-warning"></i>
              <span class="text-warning"> Pricing Scenarios </span>
            </a>
          </li>
          }
          @if(!pricingVendorsAreOnlyIframes && !disabledTpoAppMenuItems?.includes('PricingHistory')){
          <li class="nav-item" [ngClass]="{'mm-active': tab === 'pricing-history'}"
            (click)="onListItemClicked($event, 'pricing-history')">
            <a class="nav-link" [routerLink]="[basePath + '/pricing-history']">
              <i class="status-indicator pi pi-question-circle text-warning"></i>
              <span> Pricing History </span>
            </a>
          </li>
          }
          @if (!isReverseMortgage && !disabledTpoAppMenuItems?.includes('PricingScenarios')) {
          <li class="nav-item" [ngClass]="{'mm-active': tab === 'application-pricing-scenarios'}"
            (click)="onListItemClicked($event, 'application-pricing-scenarios')">
            <a class="nav-link" [routerLink]="[basePath + '/application-pricing-scenarios']">
              <i class="status-indicator pi pi-question-circle text-warning"></i>
              <span> Pricing Scenarios </span>
            </a>
          </li>
          }
          @if (featurePermissions.isAmortizationTableMenuItemVisible && !isReverseMortgage &&
          !disabledTpoAppMenuItems?.includes('AmortizationTable')) {
          <li class="nav-item" [ngClass]="{'mm-active': tab === 'amortization'}"
            (click)="onListItemClicked($event, 'amortization')">
            <a class="nav-link" [routerLink]="[basePath + '/amortization']">
              <i class="status-indicator pi pi-question-circle text-warning"></i>
              <span> Amortization Table </span>
            </a>
          </li>
          }
        </ul>
        }
      </li>

      <li [hidden]="!isFeesVisible || disabledTpoAppMenuItems?.includes('Fees')"
        (click)="onListItemClicked($event, 'fees')" class="tpo-parent-menu-item"
        [ngClass]="{'mm-active': tab === 'fees'}">

        <a [routerLink]="[basePath + '/fees']">
          <span>
            <ng-container *ngTemplateOutlet="statusIndicator; context: {status: stepStatuses.fees}"></ng-container>
            {{ showStepLabels ? 'Step ' + stepOrder['fees'] + ': ' : '' }}Fees</span></a>
      </li>

      <li [hidden]="!isDisclosuresVisible || disabledTpoAppMenuItems?.includes('Disclosures')"
        (click)="onListItemClicked($event, 'disclosures')" class="tpo-parent-menu-item disclosures-menu-item"
        [ngClass]="{'mm-active': tab === 'disclosures'}">

        <a [routerLink]="[basePath + '/disclosures']">
          <span>
            <ng-container
              *ngTemplateOutlet="statusIndicator; context: {status: stepStatuses.disclosure, tab: 'disclosures'}"></ng-container>
            {{ showStepLabels ? 'Step ' + stepOrder['disclosures'] + ': ' : '' }}{{ applicationContext.isCompanyPRMG ? 'Send Disclosures' : 'Disclosures' }}</span></a>
      </li>

      @if (!tpoSubmitted) {
      <li class="tpo-parent-menu-item submission-menu-item" (click)="onListItemClicked($event, 'submission')"
        [ngClass]="{'mm-active': tab === 'submission'}">
        <a [routerLink]="[basePath + '/submission']">
          <span>
            <ng-container
              *ngTemplateOutlet="statusIndicator; context: {status: stepStatuses.submission}"></ng-container>
            {{ showStepLabels ? 'Step ' + stepOrder['submission'] + ': ' : '' }}Submission</span>
        </a>
      </li>
      }

      @if (showUWDecision && !disabledTpoAppMenuItems?.includes('UWDecision')) {
      <li class="tpo-parent-menu-item" (click)="onListItemClicked($event, 'uwDecision')"
        [ngClass]="{'mm-active': tab === 'uwDecision'}">
        <a [routerLink]="[basePath + '/uw-decision']">
          <span>
            UW Decision</span>
        </a>
      </li>
      }

      <li class="tpo-parent-menu-item" (click)="onListItemClicked($event, 'conditions')"
        [hidden]="disabledTpoAppMenuItems?.includes('Conditions')" [ngClass]="{'mm-active': tab === 'conditions'}">
        <a [routerLink]="[basePath + '/conditions']">
          <span>Conditions</span>
        </a>
      </li>

      <li
        [hidden]="!featurePermissions.isAppraisalOrderAllowed || (isPRMG && correspondentChannels.has(applicationContext?.application?.channel)) || disabledTpoAppMenuItems?.includes('Appraisal')"
        (click)="onListItemClicked($event, 'appraisal')" class="tpo-parent-menu-item"
        [ngClass]="{'mm-active': tab === 'appraisal'}">
        <a [routerLink]="[basePath + '/appraisal']">
          <i class="status-indicator pi pi-question-circle text-warning"></i>
          <span>Appraisal</span></a>
      </li>

      @if (isPRMG && stepStatuses.submission == 'success' && isCdRequestApplicable && hasApprovedWithConditionsDate) {
      @if (applicationContext?.globalConfig?.useNewCDRequestFlow) {
      <li (click)="onListItemClicked($event, 'cdRequest')" class="tpo-parent-menu-item"
        [ngClass]="{'mm-active': tab === 'cdRequest'}">
        <a [routerLink]="[basePath + '/cd-request']">
          <i class="status-indicator pi pi-question-circle text-warning"></i>
          <span>Initial CD Request</span>
        </a>
      </li>
      } @else {
      <li (click)="onListItemClicked($event, 'cdRequest')" class="tpo-parent-menu-item"
        [ngClass]="{'mm-active': tab === 'cdRequest'}">
        <a [routerLink]="[basePath + '/cd-request']">
          <i class="status-indicator pi pi-question-circle text-warning"></i>
          <span>CD Request</span>
        </a>
      </li>
      }
      }

      @if (stepStatuses.submission == 'success' && isCorrIcdRequestApplicable &&
      !disabledTpoAppMenuItems?.includes('CDClosingDocumentsRequest')) {
      <li (click)="onListItemClicked($event, 'corrIcdRequest')" class="tpo-parent-menu-item"
        [ngClass]="{'mm-active': tab === 'corrIcdRequest'}">
        <a [routerLink]="[basePath + '/corr-icd-request']">
          <i class="status-indicator pi pi-question-circle text-warning"></i>
          <span>CD and/or Closing Documents Request</span>
        </a>
      </li>
      }

      @let isOthersMenuAActive = activeMenuId === 'contacts';
      <li class="tpo-parent-menu-item has-section-toggle"
        [hidden]="disabledTpoAppMenuItems?.includes('Others')" [ngClass]="{'mm-sub-active': isOthersMenuAActive}">
        <a href="javascript: void(0);" [attr.aria-expanded]="isContactsExpanded" (click)="toggleMenuExpansion('contacts')">
          <i class="status-indicator pi pi-question-circle text-warning"></i>
          <span>Others</span>
          <i class="ms-auto fa-solid fa-chevron-right text-muted section-toggle-icon" style="font-size: 0.7rem;" [class.is-open]="isContactsExpanded" aria-hidden="true"></i>
        </a>
        <button type="button" class="section-toggle" [attr.aria-expanded]="isContactsExpanded"
          aria-label="Others submenu" (click)="toggleMenuExpansion('contacts')"></button>
        <ul class="nav-second-level mm-collapse" style="list-style: none;" aria-expanded="false"
          [ngClass]="{'mm-show': isContactsExpanded}">
          @if (isCocVisible && !disabledTpoAppMenuItems?.includes('ChangeOfCircumstance')) {
          <li class="nav-item" (click)="onListItemClicked($event, 'change-of-circumstance')"
            [ngClass]="{'mm-active': tab === 'change-of-circumstance'}">
            <a class="nav-link" [routerLink]="[basePath + '/change-of-circumstance']">
              Change of Circumstance</a>
          </li>
          }
          @if (!isPRMG && !disabledTpoAppMenuItems?.includes('EscalationHistory')) {
          <li class="nav-item" (click)="onListItemClicked($event, 'escalation-history')"
            [ngClass]="{'mm-active': tab === 'escalation-history'}"><a class="nav-link"
              [routerLink]="[basePath + '/escalation-history']">Escalation
              History</a></li>
          }
          @if(!disabledTpoAppMenuItems?.includes('LoanDocs')){
          <li class="nav-item" (click)="onListItemClicked($event, 'loan-docs-v3')"
            [ngClass]="{'mm-active': tab === 'loan-docs-v3'}"><a class="nav-link"
              [routerLink]="[basePath + '/loan-docs-v3']">Loan Docs</a>
          </li>
          }
          @if(!disabledTpoAppMenuItems?.includes('InternalContacts')){
          <li class="nav-item" (click)="onListItemClicked($event, 'internal-contacts')"
            [ngClass]="{'mm-active': tab === 'internal-contacts'}"><a class="nav-link"
              [routerLink]="[basePath + '/internal-contacts']">Internal
              Contacts</a></li>
          }

          @if (isCompanyPulseProcessing && !disabledTpoAppMenuItems?.includes('ExternalContacts')) {
          <li class="nav-item" (click)="onListItemClicked($event, 'external-contacts')"
            [ngClass]="{'mm-active': tab === 'external-contacts'}"><a class="nav-link"
              [routerLink]="[basePath + '/external-contacts']">External
              Contacts</a></li>
          }
          @if(!disabledTpoAppMenuItems?.includes('KeyDates')){
          <li class="nav-item" (click)="onListItemClicked($event, 'key-dates')"
            [ngClass]="{'mm-active': tab === 'key-dates'}"><a class="nav-link"
              [routerLink]="[basePath + '/key-dates']">Key
              Dates</a></li>
          }
          @if (!isPRMG && !disabledTpoAppMenuItems?.includes('LoanActivity')) {
          <li class="nav-item" (click)="onListItemClicked($event, 'loan-activity')"
            [ngClass]="{'mm-active': tab === 'loan-activity'}">
            <a class="nav-link" [routerLink]="[basePath + '/loan-activity']">Loan
              Activity</a>
          </li>
          }
          @if (showArchiveCondition) {
          <li class="nav-item" (click)="onArchiveLoanClicked()">
            <a class="nav-link">Archive Loan</a>
          </li>
          }

          @if (isDeephaven && !disabledTpoAppMenuItems?.includes('eSignatureHistory')) {
          <li class="nav-item" (click)="onListItemClicked($event, 'esignature-history')"
            [ngClass]="{'mm-active': tab === 'esignature-history'}">
            <a class="nav-link" [routerLink]="[basePath + '/esignature-history']">eSignature History</a>
          </li>
          }
          <!-- <li class="nav-item"><a class="nav-link" href="javascript: void(0);"><i
                class="fa-regular fa-circle"></i>Email/SMS History</a></li> -->
          <!-- <li class="nav-item"><a class="nav-link" [routerLink]="['/tpo/app-details/' + loanId + '/prequal-detail']"><i class="fa-regular fa-circle"></i>Prequal
              Letter</a></li> -->
        </ul>
      </li>
    </ul>
  </div>
</div>
<!-- end left-sidenav-->

<ng-template #statusIndicator let-status='status' let-tab="tab">
  <i class="status-indicator pi d-inline" [ngClass]="{
    'pi-check-circle': successOrRequestedStatuses.has(status) || (disclosuresPending && tab == 'disclosures'),
    'text-success': successStatuses.has(status),
    'text-info': requestedStatuses.has(status),

    'pi-question-circle text-warning': pendingStatuses.has(status),
    'pi-times-circle text-danger': errorStatuses.has(status),
    'pi-spin pi-spinner': loadingStatuses.has(status),

    'text-muted': disclosuresPending && tab == 'disclosures'
  }"></i>
</ng-template>
